export const LOADING_BRANDS = 'brands/LOAD_BRANDS'
export const LOADING_BRANDS_SUCCESS = 'brands/LOAD_BRANDS_SUCCESS'
export const LOADING_BRANDS_FAILURE = 'brands/LOAD_BRANDS_FAILURE'
